import * as O from 'fp-ts/lib/Option';
import { pipe } from 'fp-ts/lib/function';
import * as Api from '../../api/';
import { id } from '../good';
import * as CanonicalProduct from '../product'; // as opposed to this module's Product which is a ConfigurationProduct
import * as ConfigNullProduct from './nullProduct';
import * as Options from './options';
import * as ConfigProduct from './product';
import { Effect } from 'effect';
export const fromCacheByOptions = (options, cachedGoods, configuratorDefinition) => {
    const productIdsPerPart = Api.ProductsPerPart.makeProductIdsPerPart(configuratorDefinition, Options.toApi(options));
    const productIds = Object.values(productIdsPerPart).flat();
    return Object.fromEntries(Object.entries(cachedGoods).map(([part, goods]) => [
        part,
        goods.filter(good => {
            return pipe(id(good), O.fold(() => false, productId => productIds.includes(productId)));
        }),
    ]));
};
/**
 * Construct a series of Config Goods from options. The goods will all be Products unless the option allows for a NullProduct.
 */
export const fromProductOptions = (tenant, configuratorDefinition, options) => pipe(Api.ProductsPerPart.fromProductPropertiesButEffect(tenant, configuratorDefinition, Options.toApi(options)), Effect.map(productsForParts => Object.fromEntries(Object.entries(productsForParts).map(([partKey, products]) => [
    partKey,
    products.map(p => p === null
        ? ConfigNullProduct.construct({})
        : ConfigProduct.construct({
            product: CanonicalProduct.fromApi(p),
        })),
]))));
